import React, { FunctionComponent } from 'react';
import { NavLink } from 'react-router-dom';
import { prop } from 'styled-tools';
import styled from 'styled-components';

// utils
import media from 'utils/mediaQueries';
import { AnalyticsComponent, AnalyticsProps } from '@inplayer-org/inplayer-ui';

export interface SidenavLink extends AnalyticsProps {
  label: string;
  path: string;
}

interface Props {
  links: Array<SidenavLink>;
  path: string;
}

const Container = styled.nav`
  position: sticky;
  top: 0;
  flex: 0.146;
  padding-top: 10px;

  ${media.customMaxWidth(1200)} {
    flex: 0.18;
  }
`;

const SideNavLink = styled(NavLink)`
  display: block;
  padding: 7px 0;
  line-height: 1.5em;
  color: ${prop('theme.palette.text.light')};
  transition: 300ms color ease-in-out;

  &:hover,
  &.active {
    color: ${prop('theme.palette.text.main')};
  }
`;

const Sidenav: FunctionComponent<Props> = ({ links, path }) => (
  <Container>
    {links.map((link) => (
      <AnalyticsComponent key={link.path}>
        {({ pages, tracker, merchantId, ip }) => (
          <SideNavLink
            onClick={() =>
              tracker.track({ event: 'click', type: 'link', pages, tag: `link_${link.tag}` || '', merchantId, ip })
            }
            key={link.path}
            to={`${path}${link.path}`}
            activeClassName="active"
          >
            {link.label}
          </SideNavLink>
        )}
      </AnalyticsComponent>
    ))}
  </Container>
);

export default Sidenav;
